/**
 * Mixin para cerrar modales con la tecla Escape.
 * El componente debe definir escapeToCloseModals: [{ show: 'showXModal', close: 'closeXModal' }, ...]
 */
export default {
  data() {
    return { _escapeAttached: false };
  },
  computed: {
    _anyModalOpen() {
      if (!this.escapeToCloseModals || !Array.isArray(this.escapeToCloseModals)) return false;
      return this.escapeToCloseModals.some((m) => this[m.show]);
    },
    _openModalToClose() {
      if (!this.escapeToCloseModals) return null;
      for (let i = this.escapeToCloseModals.length - 1; i >= 0; i--) {
        const m = this.escapeToCloseModals[i];
        if (this[m.show]) return this[m.close];
      }
      return null;
    },
  },
  watch: {
    _anyModalOpen: {
      handler(open) {
        if (open && !this._escapeAttached) {
          document.addEventListener("keydown", this._handleEscape);
          this._escapeAttached = true;
        } else if (!open && this._escapeAttached) {
          document.removeEventListener("keydown", this._handleEscape);
          this._escapeAttached = false;
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this._escapeAttached) {
      document.removeEventListener("keydown", this._handleEscape);
      this._escapeAttached = false;
    }
  },
  methods: {
    _handleEscape(e) {
      if (e.key !== "Escape") return;
      const closeFn = this._openModalToClose;
      if (typeof closeFn === "function") closeFn.call(this);
    },
  },
};
